import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import classNames from 'classnames';
import {
  Card,
  CardRow,
  CardCol,
  usePrevious,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const SmallCardList = ({
  title,
  icon,
  className,
  count,
  error,
  loading,
  toViewAll,
  children,
  isMobile,
  closeIfEmpty,
}) => {
  const [open, setOpen] = useState(!isMobile && !closeIfEmpty);
  // When loading state changes to false, check if list should be opened
  const prevLoading = usePrevious(loading);
  useEffect(
    () => {
      if (
        !isMobile &&
        !loading &&
        prevLoading &&
        (!closeIfEmpty || count !== 0)
      ) {
        setOpen(true);
      }
    },
    [loading, prevLoading, closeIfEmpty, count, isMobile],
  );
  return (
    <div className={classNames('card-list', className)}>
      <button
        className={classNames('card-list__header', {
          'card-list--closed': !open,
        })}
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle list open or closed"
      >
        <span className="title">
          <I18n>{title}</I18n>
        </span>
        {error ? (
          <span className="fa fa-exclamation-triangle text-danger" />
        ) : loading ? (
          <span className="fa fa-spinner fa-spin text-muted" />
        ) : typeof count === 'number' ? (
          <span className="badge badge-pill badge-subtle">{count}</span>
        ) : null}
        <span
          className={classNames('text-muted fa fa-angle-up toggle-icon ml-2', {
            'fa-rotate-180': !open,
          })}
        />
      </button>
      <Collapse isOpen={open} className="card-list__content">
        {children}
        {toViewAll && (
          <Link to={toViewAll} className="card-list__button">
            <I18n>View all</I18n>
          </Link>
        )}
      </Collapse>
    </div>
  );
};

export const SmallCardListItem = ({
  to,
  icon = 'ticket-alt',
  className,
  children,
}) => {
  return (
    <Card to={to} className={className}>
      <CardRow>
        <CardRow type="prepend" className="text-muted">
          <span className={classNames('fa fa-fw fa-2x', `fa-${icon}`)} />
        </CardRow>
        <CardCol>{children}</CardCol>
      </CardRow>
    </Card>
  );
};
